import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    formGrid: {
      marginTop: 24,
      '& .MuiSvgIcon-root': { width: 18, height: 18 },
      '& .MuiTypography-body1': {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
    formGridModal: {
      marginTop: 16,
      '& .MuiSvgIcon-root': { width: 18, height: 18 },
      '& .MuiTypography-body1': {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      },
    },
    fieldsToFill: { margin: '8px 0px' },
    executedPublications: {
      '& .MuiOutlinedInput-input': { textAlign: 'center' },
      '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        color: palette.deepBlue,
      },
      '& .MuiOutlinedInput-root': { color: palette.deepBlue, fontWeight: 500 },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.deepBlue,
        border: `2px solid ${palette.deepBlue}`,
      },
      '& .MuiFormControl-root': { width: '100%' },
    },
    limitTextBold: { color: palette.deepBlue },
    limitText: { fontSize: 12 },
    executedPublicationsModal: {
      padding: '12px 8px',
      display: 'flex',
      alignItems: 'center',
    },
    howToOptimize: {
      borderRadius: 25,
      backgroundColor: palette.backgroundBlue,
      color: palette.blue,
      marginLeft: 8,
      fontSize: 10,
      '&:hover': {
        backgroundColor: palette.backgroundBlue,
      },
      '& .MuiButton-startIcon': {
        display: 'inherit',
        marginLeft: -4,
        marginRight: 4,
      },
    },
    helpIcon: { width: '16px !important', height: '16px !important' },
    howToOptimizeHeader: { fontSize: 12, marginBottom: 8 },
    howToOptimizeDescription: {
      fontSize: 12,
      marginBottom: 4,
    },
    howToOptimizeExample: {
      fontSize: 12,
      marginBottom: 4,
      alignItems: 'center',
      display: 'flex',
    },
    blueBox: { color: palette.blue },
    imageExamples: {
      width: '100%',
      margin: '4px 0px 12px 0px',
      border: `1px solid ${palette.blue}`,
      borderRadius: 8,
    },
    expandIcon: { color: palette.blue, width: 16, height: 16 },
    headerText: { fontSize: 14 },
    divider: {
      width: '100%',
      marginTop: 22,
    },
    actionsGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '24px 0px',
    },
    seeModelsButtons: {
      color: palette.blue,
      margin: 0,
      borderColor: palette.blue,
    },
    buttonsModal: { marginBottom: 8 },
    inProgress: { fontSize: 14, marginLeft: 8 },
    helpIconForm: {
      zIndex: 2,
      color: palette.grey500,
    },
    helpIconFormServer: {
      zIndex: 2,
      color: palette.grey500,
    },
    optimizeChecks: {
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      '& .MuiFormControl-root': {
        display: 'contents',
      },
      '& .MuiGrid-root': {
        display: 'contents',
      },
    },
    closeModalGrid: {
      marginTop: 16,
      marginBottom: -6,
      marginRight: 0,
    },
  });
